import axiosPublicClient from "../../../../axiosPublicClient"

// Uploads one locally-selected document (presigned PUT minted by the response-key-gated
// media-url endpoint) and returns its asset key.
const uploadFile = async ({ responseKey, file, fileName, fileExtension }) => {

    const response = await axiosPublicClient.post('/pre-adverse-action-response-media-url', {
        responseKey,
        fileName,
        fileExtension,
    })

    if (!response?.data?.url || !response?.data?.key) {
        throw new Error('Upload URL or key missing from response')
    }

    const { url, key } = response.data

    await axiosPublicClient.put(url, file, {
        headers: {
            'Content-Type': file.type,
        },
    })

    return key
}

// Documents are selected locally on the form and only uploaded here, at submit time
// (same pattern as the create-TruCheck dialog): upload every file first, then submit
// the response with the resulting keys.
const service = async ({ responseKey, comment, documents }) => {

    const uploadedDocuments = await Promise.all(
        (documents || []).map(async (document) => ({
            key: await uploadFile({
                responseKey,
                file: document.file,
                fileName: document.fileName,
                fileExtension: document.fileExtension,
            }),
            fileName: document.originalName,
            // The QA-requested upload slot this file answers (null for a free/extra document).
            requestedItemId: document.requestedItemId || null,
        }))
    )

    const result = await axiosPublicClient.post('/submit-pre-adverse-action-response', {
        responseKey,
        comment,
        documents: uploadedDocuments,
    })

    return result.data
}

export default service
